import { getData, postData, putData } from "adminApi/apiClient";

// ************** Room Checkin API ************************

export const createRoomBooking = async ({ data }) => {
  try {
    const result = await postData(`/room-checkin-booking/`, data);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(
      "Create Room Checkin API error:",
      error.status === 400 ? error.error : error.message,
    );
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data.errors : error.message,
        status: error.status,
      },
    };
  }
};

export const updateRoomBooking = async ({ id, data }) => {
  try {
    const result = await putData(`/room-checkin-booking/${id}`, data);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(
      "Upadte Room Checkin API error:",
      error.error || error.message,
    );
    return {
      data: {
        success: false,
        error: error.data.errors || error.message,
        status: error.status,
      },
    };
  }
};

export const viewCheckinWithId = async (id) => {
  try {
    const result = await getData(`/room-checkin-booking/view-ckeckin/${id}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(`Get View Booking API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

export const getBookingById = async (id) => {
  try {
    const result = await getData(`/room-checkin-booking/${id}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(`Get Room Checkin data API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

export const GetAllBookings = async (
  { page = 1, limit = 10, search = "" },
  signal = null,
) => {
  try {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search: search,
    });

    const result = await getData(
      `/room-checkin-booking/?${queryParams}`,
      {},
      {},
      signal,
    );
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error(`Get Room Checkin List with pagination API error:`, error);
    return {
      success: false,
      ...error,
    };
  }
};

//************* Room CheckIn Related API ***************************/

export const getRoomBookingTypes = async () => {
  try {
    const result = await getData(`/room-checkin-booking/booking-types`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(
      "Room API error:",
      error.status === 400 ? error.error : error.message,
    );
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};

export const getBookingRef = async (id) => {
  try {
    const result = await getData(`/room-checkin-booking/booking-source/${id}`);
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error(
      "Room API error:",
      error.status === 400 ? error.error : error.message,
    );
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};

export const getAllRoomTypes = async () => {
  try {
    const result = await getData(`/room-checkin-booking/room-types`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(
      "Room API error:",
      error.status === 400 ? error.error : error.message,
    );
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};

export const getRoomNumbers = async (id, bodyData) => {
  try {
    const result = await postData(
      `/room-checkin-booking/room-list/${id}`,
      bodyData,
    );
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error(
      "Room API error:",
      error.status === 400 ? error.error : error.message,
    );

    return {
      success: false,
      error: error.status === 400 ? error.error : error.message,
      status: error.status || 500,
    };
  }
};

export const getComplementry = async (id) => {
  try {
    const result = await getData(`/room-checkin-booking/complementry/${id}`);
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error(
      "Room API error:",
      error.status === 400 ? error.error : error.message,
    );
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};
export const getCombinedRoomInfo = async (id, bodyData) => {
  try {
    const roomdata = await postData(
      `/room-checkin-booking/room-list/${id}`,
      bodyData,
    );

    const data = roomdata?.data || {};
    console.log("Combined Room API result:", data);

    return {
  success: true,
  rooms: data?.rooms || [],
  offer: data?.offer || null,        // full object
  offerValue: data?.offer?.offer || 0, // numeric value
  complementary: data?.complementary || [],
  room_type_info: data?.room_type_info || {}, // include room type details if needed
};
  } catch (error) {
    console.error(
      "Combined Room API error:",
      error.status === 400 ? error.error : error.message,
    );
    return {
      success: false,
      error: error.status === 400 ? error.error : error.message,
      status: error.status || 500,
    };
  }
};

export const getExistingCustomer = async (contactNumber) => {
  try {
    const result = await getData(
      `/room-checkin-booking/customers/${contactNumber}`,
    );
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error(
      "Room API error:",
      error.status === 400 ? error.error : error.message,
    );
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};

export const getAllPaymentMethods = async () => {
  try {
    const result = await getData(`/room-checkin-booking/payment-methods`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(
      "Room API error:",
      error.status === 400 ? error.error : error.message,
    );
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};

export const getChargePercent = async () => {
  try {
    const result = await getData(`/room-checkin-booking/tax-charges`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(
      "Tax API error:",
      error.status === 400 ? error.error : error.message,
    );
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};

export const createNewCustomer = async ({ data }) => {
  try {
    const result = await postData(
      `/room-checkin-booking/create-customer`,
      data,
      {
        "Content-Type": "multipart/form-data",
      },
    );
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Create New Customer API error:`, error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data.error : error.message,
        status: error.status,
      },
    };
  }
};
